import {MapControl, MapControlProps, withLeaflet} from 'react-leaflet';
import L from "leaflet";

interface AutoZoomButtonProps extends MapControlProps {
    toggleAutoZoom: Function,
    autoZoomEnabled: boolean
}

class AutoZoomButton extends MapControl<AutoZoomButtonProps, L.Control.EasyButton> {

    createLeafletElement(props: AutoZoomButtonProps): L.Control.EasyButton {

        return new L.Control.EasyButton({
            id: 'toggleAutoZoomBtn',
            states: [
                {
                    stateName: 'disabled',
                    icon: 'fas fa-expand inactive',
                    title: 'Automatisk zoom er ikke aktivert',
                    onClick: () => {
                        this.props.toggleAutoZoom();
                    }
                },
                {
                    stateName: 'enabled',
                    icon: 'fas fa-expand active',
                    title: 'Automatisk zoom er aktivert',
                    onClick: () => {
                        this.props.toggleAutoZoom();
                    }
                }
            ]
        });
    }

    componentDidUpdate() {
        this.props.autoZoomEnabled
            ? this.leafletElement.state('enabled')
            : this.leafletElement.state('disabled')
    }

}

export default withLeaflet(AutoZoomButton);
